import React from "react";
import SectionSteppedProcess from "../../../containers/sections/SectionSteppedProcess";
import type { SectionSteppedProcessProps } from "../../sections/SectionSteppedProcess/SectionSteppedProcess";

export const getParagraphSteppedProcessProps = (
	data: Queries.ParagraphSteppedProcessDataFragment,
): SectionSteppedProcessProps => {
	return {
		heading: data.relationships?.field_stepped_process_node.title,
		jumpLinksTitle:
			data.relationships?.field_stepped_process_node.field_jump_links_title,
		htmlIntroText:
			data.relationships?.field_stepped_process_node.field_stepped_intro_text,
		steps:
			data.relationships?.field_stepped_process_node.relationships?.field_step.map(
				(step) => ({
					title: step.field_step_title,
					introText: step.field_step_intro_text?.value,
					url: step.field_step_link?.uri,
					urlTitle: step.field_step_link?.title,
					imageOrText: [...step.relationships.field_image_text],
				}),
			),
	};
};
export const ParagraphSteppedProcess: React.FC<SectionSteppedProcessProps> = ({
	heading,
	jumpLinksTitle,
	htmlIntroText,
	steps,
}) => {
	return (
		<SectionSteppedProcess
			heading={heading}
			htmlIntroText={htmlIntroText}
			steps={steps}
			jumpLinksTitle={jumpLinksTitle}
		/>
	);
};

export default ParagraphSteppedProcess;
